export default {
  getOrders: (state) => {
    return state.orders || 0
  },
  getUser: state => state.user,
  getRent: state => state.rent
}



// WEBPACK FOOTER //
// ./src/store/getters.js